export default "__VITE_ASSET__tAGlfx67__"